import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { FakeText } from '@totalsoft/rocket-ui';

function WrappedFakeText({ lines = 10, onPaper, ...rest }) {
  return (
    <Box sx={{ width: '100%', ...rest?.sx }} {...rest}>
      <FakeText lines={lines} onPaper={onPaper} />
    </Box>
  );
}

WrappedFakeText.propTypes = {
  lines: PropTypes.number,
  onPaper: PropTypes.bool
};

export default WrappedFakeText;
